import { IconButton, IconButtonProps, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import './IconButtonElement.scss';
// const cx = classNames.bind(styles);

interface IconButtonElementProps extends IconButtonProps {
    customType?: ColorButton
    children: ReactNode
}

type ColorButton = "Primary" | "Secondary" | "Transparent"

export default function IconButtonElement(props: IconButtonElementProps) {
    const combineClassName = `icon-button-element ${props?.className ?? ''}`

    const theme = useTheme()
    let color = theme.palette.primary.main
    if (props?.customType === 'Secondary') {
        color = theme.palette.secondary.main
    } else if (props?.customType === 'Transparent') {
        color = theme.palette.transparent
    }
    const combineStyle = { backgroundColor: color, ...props?.sx }
    return (
        <IconButton style={{
            display: "inline-flex", alignItems: "center", position: 'relative',
            cursor: "pointer", textAlign: "center", verticalAlign: "middle",
            fontSize: "1.5rem",
            outline: "0px",
            margin: "0px",
            textDecoration: "none",
            flex: "0 0 auto",
            padding: "8px",
            // borderRadius: '50%',
        }}  {...props} sx={combineStyle} className={combineClassName} >
            {props.children}
        </IconButton>
    )
}